<!--
 * @Autor: yingna.gao
 * @Date: 2022-07-06 14:31:52
 * @LastEditTime: 2022-07-18 16:44:31
 * @LastEditors: yingna.gao
 * @Description:
 * @FilePath: /common-web/src/views/standard/cockpit/components/order-today-statistics.vue
-->
<template>
  <el-card class="tody-order-statistics-wrapper">
    <div slot="header" class="clearfix">
      <span>今日工单统计</span>
    </div>
    <div class="tody-order-statistics-content">
      <div v-for="item in todayOrderList" :key="item.status" class="content-item">
        <p class="content-item-text">{{ item.name }}</p>
        <p class="content-item-number">{{ item.count }}</p>
      </div>
    </div>
  </el-card>
</template>

<script>
import cockpitApi from "@/api/cockpit/cockpit";
export default {
  name: "OrderTodayStatistics",
  data() {
    return {
      todayOrderList: [
        { status: "CREATED", count: "0", name: "已创建" },
        { status: "RECEIVED", count: "0", name: "待处理" },
        { status: "ONGOING", count: "0", name: "进行中" },
        { status: "SUSPENDED", count: "0", name: "已挂起" },
        { status: "OUTSOURCING", count: "0", name: "已委外" },
        { status: "CLOSED", count: "0", name: "已完成" }
      ]
    };
  },
  created() {
    this.getTodayOrderStatistic();
  },
  methods: {
    getTodayOrderStatistic() {
      cockpitApi.getTodayOrderStatistic().then(result => {
        if (result.code === 200 && result.data) {
          const todayOrder = result.data || [];
          this.todayOrderList.forEach(order => {
            const currentOrderObj = todayOrder.find(currentOrder => currentOrder.status === order.status);
            if (currentOrderObj) {
              order.count = currentOrderObj.count || 0;
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tody-order-statistics-wrapper{
    width:100%;
    height:100%;
}
.tody-order-statistics-content {
  height: 82px;
  display: flex;
  text-align: center;
  align-items: center;
  .content-item {
    flex: 1;
    .content-item-text {
      margin-bottom: 8px;
      font-size: 16px;
      color: #505363;
    }
    .content-item-number {
      font-size: 32px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: 600;
    }
  }
}
.tody-order-statistics-wrapper.el-card.is-always-shadow {
  box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.03) !important;
}
.tody-order-statistics-wrapper.el-card {
  border: 1px solid #ebecef !important;
}
// .custom-theme.el-card__body {
//   padding: 16px 24px !important;
// }
.tody-order-statistics-wrapper{
 ::v-deep .el-card__body {
  padding: 16px 24px !important;
}
::v-deep .el-card__header {
  padding: 0px 24px !important;
  font-size: 16px !important;
  color: #21252e !important;
  font-weight: 600 !important;
  height: 44px;
  line-height: 44px;
}
}
</style>
